import {TableCell} from '@material-ui/core';
import clsx from 'clsx';
import React, {ReactNode} from 'react';
import styles from './TableDataCell.module.scss';

interface Props {
  data: ReactNode;
  className?: string;
  title?: string;
  small?: boolean;
  rightAlign?: boolean;
  wrapText?: boolean;
  withMinWidth?: boolean;
  width?: string;
  colSpan?: number;
}

const TableDataCell = (
  {
    data,
    className,
    title,
    small = false,
    rightAlign = false,
    width,
    colSpan,
    wrapText = false,
    withMinWidth = false
  }: Props
): React.ReactElement => {
  const classes = clsx(styles.cell,
    className,
    {
      [styles.cellSmall]: small,
      [styles.cellAlignRight]: rightAlign,
      [styles.cellWrapText]: wrapText,
      [styles.cellWithMinWidth]: withMinWidth
    });
  return <TableCell width={width} title={title} className={classes} colSpan={colSpan}>{data}</TableCell>;
};
export default TableDataCell;
